cb.define(['common/common_VM.Extend.js'], function (common) {
    //String转换Int（位运算）
    var setCheckBoxEnum = function (data) {

        if (data != undefined) {
            var oldData = data.split(",");
            var result = 0;
            if (oldData != "") {
                oldData.forEach(function (item, index) {
                    result += Math.pow(2, parseInt(item) - 1);
                });
            }
            return result;
        } else {
            return 0;
        }

    };

    var PM_pmc_relationsales_VM_Extend = {
        doAction: function (name, viewmodel) {
            if (this[name])
                this[name](viewmodel);
        },

        init: function (viewmodel) {
            let mode = viewmodel.getParams().mode;
            var nowDates = new Date().format('yyyy-MM-dd hh:mm:ss');
            //viewmodel.get("temporary").setState('defaultSelectedRowIndexes', true);

            const displayIsGetmemberPrice = (viewmodel) => {
                if (viewmodel.get("memberLevelAll").getValue() == 0 && viewmodel.get("combinationsalesmemberlevel").getShowValue()
                    && viewmodel.get("combinationsalesmemberlevel").getShowValue().length == 1) {
                    viewmodel.get("isGetmemberPrice").setDisabled(false);
                } else {
                    viewmodel.get("isGetmemberPrice").setValue(false);
                    viewmodel.get("isGetmemberPrice").setDisabled(true);
                }
            }

            const displayPrice = (viewmodel) => {
                //仅勾线下门店
                if (viewmodel.get('applyOnlineChannel').getValue() == 0 && viewmodel.get('applyOffLineChannel').getValue() == 1) {
                    let pro_refCode = "pmc_product";
                    let pro_refRetId = {
                        "productId": "id", "productName": "cName", "price": "fMarkPrice", "sProductCode": "code",
                        "productPicUrl": "url", "skuDescription": "modelDescription"
                    };
                    viewmodel.get("combinationProducts").getEditRowModel().get("sProductCode").setRefCode(pro_refCode, JSON.stringify(pro_refRetId));
                } else {
                    let pro_refCode = "pmc_product";
                    let pro_refRetId = {
                        "productId": "id", "productName": "cName", "price": "fSalePrice", "sProductCode": "code",
                        "productPicUrl": "url", "skuDescription": "modelDescription"
                    };
                    viewmodel.get("combinationProducts").getEditRowModel().get("sProductCode").setRefCode(pro_refCode, JSON.stringify(pro_refRetId));
                }
            }

            viewmodel.get('memberLevelAll').on('afterValueChange', () => {
                displayIsGetmemberPrice(viewmodel);
            })

            viewmodel.get("combinationsalesmemberlevel").on('afterValueChange', () => {
                displayIsGetmemberPrice(viewmodel);
            })

            viewmodel.on('afterLoadData', function (data) {

                if (viewmodel.get("applyOffLineChannel")) {
                    viewmodel.get("applyOffLineChannel").setValue(false);
                }
                let auditStatusModel = viewmodel.get('applicableChannel');
                if (auditStatusModel) {
                    let dataSource = auditStatusModel.getState('dataSource');
                    let newSource = [];
                    dataSource && dataSource.forEach(data => {
                        //丢弃线下零售
                        if (data.value != "1") {
                            newSource.push({value: data.value, nameType: 'text', text: data.text});
                        }
                    });
                    auditStatusModel.setDataSource(newSource);
                }

                viewmodel.get('mainProductId_price').setDisabled(true);
                viewmodel.get('mainProductId_modelDescription').setDisabled(true);
                viewmodel.get('mainProductCode').setDisabled(true);
                displayPrice(viewmodel);
                displayIsGetmemberPrice(viewmodel);
                common.displayChannel(viewmodel, 'relationsales');
                if (viewmodel.get('applyOnlineChannel').getValue() == 0 && viewmodel.get('applyOffLineChannel').getValue() == 1) {
                    viewmodel.get('iSendPoint').setVisible(true);
                    viewmodel.get('applicableChannel').setValue(["1"]);
                } else if (viewmodel.get('applyOnlineChannel').getValue() == 1 && viewmodel.get('applyOffLineChannel').getValue() == 0) {
                    viewmodel.get('iSendPoint').setVisible(false);
                    viewmodel.get('applicableChannel').setValue(["0"]);
                } else if (viewmodel.get('applyOnlineChannel').getValue() == 1 && viewmodel.get('applyOffLineChannel').getValue() == 1) {
                    viewmodel.get('iSendPoint').setVisible(false);
                    viewmodel.get('applicableChannel').setValue(["0", "1"]);
                }
                ;
                if (this.get('applyOnlineChannel').getValue() == false) {
                    viewmodel.get("terminalType").setVisible(false);
                } else {
                    viewmodel.get("terminalType").setVisible(true);
                }

                if (this.get('applyOffLineChannel').getValue() == false) {
                    viewmodel.get('offLineStore').setVisible(false);
                    viewmodel.get('combinationSalesStore').setVisible(false);
                } else {
                    viewmodel.get('offLineStore').setVisible(true);
                    if (this.get('offLineStore').getValue() == 1 || this.get('offLineStore').getValue() == 0) {
                        viewmodel.get('combinationSalesStore').setVisible(false);
                    } else {
                        viewmodel.get('combinationSalesStore').setVisible(true);
                    }
                }
                if (this.get('memberLevelAll').getValue() == 0) {
                    viewmodel.get('combinationsalesmemberlevel').setVisible(true);
                } else {
                    viewmodel.get('combinationsalesmemberlevel').setVisible(false);
                }

                if (this.getParams().mode === 'add') {
                    //viewmodel.get("temporary").appendRow();
                } else if (this.getParams().mode === 'edit') {

                }

            });

            /**点击按钮弹出参照前事件
             *返回true则继续进行弹出参照操作，返回false则终止弹出
             */
            viewmodel.get("combinationSalesStore").on('beforeBrowse', function () {
                return true;
            });

            viewmodel.get("mainProduct_Name").on('beforeBrowse', function () {
                let mainProductId = viewmodel.get("mainProductId").getValue();
                //没有选主商品
                if (!mainProductId) {
                    common.productReferBrowseSimple(viewmodel, this, "iskuId", "combinationProducts", null);
                } else {
                    let condition = {
                        "isExtend": true,
                        simpleVOs: []
                    };
                    common.addProductReferCondition(viewmodel, false, condition, null, null, false);
                    condition.simpleVOs.push({
                        field: 'id',
                        op: 'eq',
                        value1: mainProductId
                    });
                    this.setFilter(condition);
                }
                return true;
            });

            viewmodel.get("memberLevelAll").on('beforeBrowse', function () {
                return true;
            });

            viewmodel.get("combinationProducts").on("beforeBrowse", function (data) {
                let mainProductCode = viewmodel.get("mainProductCode").getValue();
                let banIds;
                if (mainProductCode) {
                    banIds = [];
                    banIds.push(mainProductCode);
                }
                common.productReferBrowse(viewmodel, data, "sProductCode", "sProductSkuCode", "iskuId",
                    "combinationProducts", 'memberLevelAll', 'isGetmemberPrice',
                    "combinationsalesmemberlevel", "lMemberLeverId", false, banIds);
                return true;
            });

            viewmodel.get('applicableChannel').on('afterValueChange', function (data) {
                viewmodel.get('terminalType').setVisible(false);
                viewmodel.get('offLineStore').setVisible(false);
                viewmodel.get('combinationSalesStore').setVisible(false);
                viewmodel.get('applyOnlineChannel').setValue(false);
                viewmodel.get('applyOffLineChannel').setValue(false);
                viewmodel.get('iSendPoint').setVisible(false);
                var on = 0;
                for (var i = 0; i < data.value.length; i++) {
                    if (data.value[i].value == 0) {
                        viewmodel.get('terminalType').setVisible(true);
                        viewmodel.get('applyOnlineChannel').setValue(true);
                        viewmodel.get('iSendPoint').setVisible(false);
                        on = 1;
                    } else if (data.value[i].value == 1) {
                        viewmodel.get('applyOffLineChannel').setValue(true);
                        viewmodel.get('offLineStore').setVisible(true);
                        if (viewmodel.get('promotionParams')) {
                            let userType = viewmodel.get('promotionParams').userType;
                            //超级管理员
                            if (userType != 0 && viewmodel.get('offLineStore').getValue() == 1) {
                                viewmodel.get('offLineStore').setValue(2);
                            }
                        }
                        if (viewmodel.get('offLineStore').getValue() == 1) {
                            viewmodel.get('combinationSalesStore').setVisible(false);
                        } else {
                            viewmodel.get('combinationSalesStore').setVisible(true);
                        }
                        if (on == 0) {
                            viewmodel.get('iSendPoint').setVisible(true);
                        }
                    }
                }
                displayPrice(viewmodel);
            });
            //买家范围控制事件
            viewmodel.get('memberLevelAll').on('afterValueChange', function (data) {
                if (data.value.value === '0') {
                    viewmodel.get("combinationsalesmemberlevel").setVisible(true);
                } else {
                    viewmodel.get('combinationsalesmemberlevel').setVisible(false);
                }
            });
            //线下门店控制事件
            viewmodel.get('offLineStore').on('afterValueChange', function (data) {
                if (data.value.value === '1') {
                    viewmodel.get("combinationSalesStore").setVisible(false);
                } else {
                    viewmodel.get('combinationSalesStore').setVisible(true);
                }
            });
            //清除全部商品
            viewmodel.on('batchProDelete', function (args) {
                debugger
                let counts = viewmodel.get('combinationProducts').getRowsCount();
                var rowIndexes = [];
                for (let i = counts - 1; i >= 0; i--) {
                    rowIndexes.push(i);
                }
                viewmodel.get("combinationProducts").deleteRows(rowIndexes);
            })

            viewmodel.on('beforeEdit', function (args) {
                return common.checkAuth(viewmodel.originalParams.id, 'pmc_relationsales');
            })

            viewmodel.get("mainProduct_Name").on('beforeValueChange', args => {
                common.mainURL(args, false);
            });

            //保存前数据处理
            viewmodel.on('beforeSave', function (data) {

                var obj = JSON.parse(data.data.data);

                obj.terminalType = setCheckBoxEnum(obj.terminalType);
                obj.activityType = setCheckBoxEnum(obj.activityType);

                if (this.get('applyOnlineChannel').getValue() == '1' && obj.terminalType == 0) {
                    cb.utils.alert('适用线上商城时，适用终端不可为空', 'warning');
                    return false;
                }

                if (this.get('memberLevelAll').getValue() == '0' && this.get('combinationsalesmemberlevel').getShowValue() == '') {
                    cb.utils.alert('指定会员不可为空', 'warning');
                    return false;
                } else if (this.get('memberLevelAll').getValue() != '0') {
                    obj.combinationsalesmemberlevel = [];
                }

                if (this.get('applyOffLineChannel').getValue() == '1' && this.get('offLineStore').getValue() != '1' && this.get('combinationSalesStore').getShowValue() == '') {
                    cb.utils.alert('指定门店不可为空', 'warning');
                    return false;
                } else if (this.get('applyOffLineChannel').getValue() == '0') {
                    obj.offLineStore = 1;
                    if (obj.memberLevelAll == 1) {
                        obj.memberLevelAll = 2;
                    }
                } else if (this.get('applyOffLineChannel').getValue() == '1' && this.get('offLineStore').getValue() == '1') {
                    obj.combinationSalesStore = [];
                }

                // if (mode == 'add') {
                //     if (viewmodel.get('startDate').getValue() <= nowDates) {
                //         cb.utils.alert('开始时间大于当前时间', 'warning');
                //         return false;
                //     }
                // }

                if (this.get('startDate').getValue() >= this.get('endDate').getValue()) {
                    cb.utils.alert('活动结束时间必须大于开始时间', 'warning');
                    return false;
                }
                if (viewmodel.get('combinationProducts').getRows() == '') {
                    cb.utils.alert('商品信息不能为空', 'warning');
                    return false;
                }


                data.data.data = JSON.stringify(obj);

            });
        }
    };
    try {
        module.exports = PM_pmc_relationsales_VM_Extend;
    } catch (error) {

    }
    return PM_pmc_relationsales_VM_Extend;
});



// WEBPACK FOOTER //
// ./src/client/business/PM/PM_pmc_relationsales_VM.Extend.js